import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { browserTracingIntegration, replayIntegration, setTag } from '@sentry/angular';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

export const isLocalhost = window.location.hostname === 'localhost';

function runApp(config = appConfig) {
  bootstrapApplication(AppComponent, config).catch((err) => console.error(err));
}

async function initSentry(): Promise<void> {
  try {
    const response = await fetch('/assets/version.json?v=' + Math.random());
    const versionData = await response.json();
    const [version, versionDate] = versionData.version.split('|').map((s) => s.trim());

    Sentry.init({
      dsn: environment.sentryDsnUrl,
      sendDefaultPii: true,
      integrations: [browserTracingIntegration(), replayIntegration()],
      tracesSampleRate: 0.01,
      tracePropagationTargets: [
        /^https:\/\/app-quality-dev\.xfarm\.ag/,
        /^https:\/\/preprod\.xfarm\.ag/,
        /^https:\/\/app\.xfarm\.ag/,
        /^https:\/\/analytics\.xfarm\.ag/,
      ],
      replaysSessionSampleRate: 0.0,
      replaysOnErrorSampleRate: 0.0,
      release: `${environment.themeConfig.brand.toLowerCase()}-${version}`,
      environment: environment.themeConfig.textName.toUpperCase(),
    });

    setTag('package', environment.themeConfig.brand.toLowerCase());
    setTag('version', version);
    setTag('release-date', versionDate);
  } catch (err) {
    console.error('Failed to load version file or init Sentry:', err);
  }
}

if (!isLocalhost && environment.sentryDsnUrl && environment.enableSentry) {
  initSentry().finally(() => runApp());
} else {
  runApp();
}
